export const translations = {
  fr: {
    // ─── Header / Navigation ───
    'nav.appartements': 'Appartements',
    'nav.album': 'Album photos',
    'nav.faq': 'FAQ',
    'nav.darkMode': 'Mode sombre',
    'nav.lightMode': 'Mode clair',
    'nav.settings': 'Paramètres',

    // ─── Hero accueil ───
    'hero.location': 'La Grave · Hautes-Alpes',
    'hero.title': 'La Marmotte Joyeuse',
    'hero.subtitle': "Location d'appartements rénovés face à la Meije.",
    'hero.cta': 'Voir nos appartements',
    'hero.scroll': 'Scroll',

    // ─── Section histoire ───
    'story.label': 'Notre Histoire',
    'story.title': 'Bienvenue à La Marmotte Joyeuse',
    'story.p1': "Maison du 19\u1D49 siècle entièrement rénovée en 2026, au cœur du magnifique village de La Grave, face à la Meije. Une maison de village authentique qui abrite trois appartements aux noms de minéraux emblématiques de l'Oisans :",
    'story.minerals': 'Quartz, Sidérite et Épidote',
    'story.p2': 'Découvrez la vie dans un village de montagne classé « Plus Beaux Villages de France » — commerces, restaurants et téléphérique accessibles à pied, GR 54 à deux pas.',

    // ─── Section localisation ───
    'location.title': 'Notre localisation',
    'location.address': '2 Impasse du Garde Champêtre, 05320 La Grave',
    'location.openMaps': 'Ouvrir dans Google Maps',

    // ─── SEO accueil ───
    'seo.home.title': 'La Marmotte Joyeuse - Hébergement de charme dans les Alpes | La Grave',
    'seo.home.description': 'Découvrez La Marmotte Joyeuse, votre refuge de montagne au cœur des Alpes françaises. Appartements confortables, vue panoramique, activités montagne. Réservez votre séjour inoubliable à La Grave.',

    // ─── Page appartements ───
    'apts.title': 'Nos Appartements',
    'apts.subtitle': 'Trois appartements rénovés au cœur du village de La Grave, face à la Meije.',
    'apts.features': 'Caractéristiques',
    'apts.viewApt': 'Voir cet appartement',
    'apts.quartz.title': 'Appartement Quartz',
    'apts.quartz.desc': 'Duplex 35 m² · 2 personnes · Vue Meije',
    'apts.quartz.price': 'À partir de 85€/nuit',
    'apts.quartz.f1': 'Duplex cosy',
    'apts.quartz.f2': 'Idéal seul ou à deux',
    'apts.quartz.f3': 'Vue sur La Meije',
    'apts.siderite.title': 'Appartement Sidérite',
    'apts.siderite.desc': 'Plain-pied 63 m² · 4 personnes · Vue plein sud',
    'apts.siderite.price': 'À partir de 115€/nuit',
    'apts.siderite.f1': 'De plain-pied, rez-de-chaussée',
    'apts.siderite.f2': 'Vue plein sud sur le glacier',
    'apts.siderite.f3': 'Idéal pour 4 personnes',
    'apts.epidote.title': 'Appartement Épidote',
    'apts.epidote.desc': 'Grand duplex 83 m² · 6 personnes · Balcon',
    'apts.epidote.price': 'À partir de 145€/nuit',
    'apts.epidote.f1': 'Grand duplex',
    'apts.epidote.f2': 'Idéal en famille ou entre amis',
    'apts.epidote.f3': '6 personnes',
    'seo.apts.title': 'Nos Appartements - La Marmotte Joyeuse | Hébergement de charme à La Grave',
    'seo.apts.description': 'Découvrez nos appartements Quartz, Sidérite et Épidote. Vue panoramique sur La Meije, équipements modernes, séjour inoubliable à La Grave dans les Alpes.',

    // ─── Appartement Quartz ───
    'quartz.label': 'Appartement',
    'quartz.name': 'Quartz',
    'quartz.tagline': 'Duplex · 2 personnes · La Grave',
    'quartz.desc': "L'appartement Quartz est un duplex chaleureux conçu pour deux personnes, idéal pour profiter d'un séjour à La Grave face à la Meije. Avec sa pièce de vie lumineuse, sa cuisine équipée et sa chambre à l'étage, Quartz offre un cadre confortable pour découvrir la montagne en toute simplicité. Situé au cœur du village, il permet d'accéder facilement aux sentiers, aux commerces et aux activités emblématiques de La Grave, tout en profitant d'un environnement calme et authentique.",
    'quartz.descTitle': 'Description',
    'quartz.equipTitle': 'Équipements',
    'quartz.equip': [
      'Duplex de 35 m² pour 2 personnes',
      'Vue Meije depuis la pièce de vie',
      "Chambre à l'étage avec salle de bain attenante",
      'Cuisine équipée (plaques, four, lave-vaisselle, petit électroménager)',
      'Espace salon avec TV connectée',
      'Salle de bain avec douche et rangements',
      'Accès au ski room avec casier privatif',
      'Connexion Wi-Fi haut débit',
      'Logement situé au cœur du village de La Grave',
    ],
    'quartz.infoTitle': 'Informations pratiques',
    'quartz.capacity': 'Capacité',
    'quartz.capacityVal': '2 personnes',
    'quartz.surface': 'Surface',
    'quartz.surfaceVal': '35 m² (duplex)',
    'quartz.rate': 'Tarif',
    'quartz.rateVal': 'À partir de 85 €',
    'quartz.perNight': '/ nuit',
    'quartz.bookAirbnb': 'Réserver sur Airbnb',
    'quartz.back': 'Retour aux appartements',
    'seo.quartz.title': 'Appartement Quartz – Duplex 2 personnes à La Grave | La Marmotte Joyeuse',
    'seo.quartz.description': 'Duplex de 35 m² pour 2 personnes, vue sur la Meije depuis la pièce de vie. Cuisine équipée, salle de bain, Wi-Fi, ski room privatif. Au cœur du village de La Grave.',

    // ─── Appartement Sidérite ───
    'siderite.label': 'Appartement',
    'siderite.name': 'Sidérite',
    'siderite.tagline': 'Plain-pied · 4 personnes · La Grave',
    'siderite.desc': "L'appartement Sidérite est un logement de plain-pied pensé pour accueillir jusqu'à quatre personnes, idéal pour un séjour en famille ou entre amis à La Grave. Orienté plein sud, il offre une pièce de vie confortable et lumineuse, ouverte sur la Meije, avec un accès facile et direct depuis le cœur du village. Sidérite constitue un point de départ pratique pour profiter des activités de montagne, des commerces et de l'ambiance authentique du village, été comme hiver.",
    'siderite.descTitle': 'Description',
    'siderite.equipTitle': 'Équipements',
    'siderite.equip': [
      'Appartement de plain-pied de 63 m² pour 4 personnes',
      'Orientation plein sud avec vue sur la Meije',
      'Deux chambres (1 lit double et 2 lits simples)',
      'Cuisine équipée (plaques, four, lave-vaisselle, petit électroménager)',
      'Espace salon avec poêle à bois et TV connectée',
      'Salle de bain avec douche, lave-linge et rangements',
      'WC séparés',
      'Accès au ski room avec casier privatif',
      'Connexion Wi-Fi haut débit',
      'Logement situé au cœur du village de La Grave',
    ],
    'siderite.infoTitle': 'Informations pratiques',
    'siderite.capacity': 'Capacité',
    'siderite.capacityVal': '4 personnes',
    'siderite.surface': 'Surface',
    'siderite.surfaceVal': '63 m² (plain-pied)',
    'siderite.rate': 'Tarif',
    'siderite.rateVal': 'À partir de 115 €',
    'siderite.perNight': '/ nuit',
    'siderite.bookAirbnb': 'Réserver sur Airbnb',
    'siderite.back': 'Retour aux appartements',
    'seo.siderite.title': 'Appartement Sidérite – Plain-pied 4 personnes à La Grave | La Marmotte Joyeuse',
    'seo.siderite.description': 'Appartement de plain-pied 63 m² pour 4 personnes, vue plein sud sur le glacier. Cuisine équipée, Wi-Fi, ski room. Village de La Grave classé, face à la Meije.',

    // ─── Appartement Épidote ───
    'epidote.label': 'Appartement',
    'epidote.name': 'Épidote',
    'epidote.tagline': 'Grand duplex · 6 personnes · La Grave',
    'epidote.desc': "L'appartement Épidote est un grand duplex lumineux pouvant accueillir jusqu'à six personnes. Réparti sur deux niveaux, il offre des volumes généreux et une organisation adaptée aux séjours en groupe, tout en conservant une atmosphère chaleureuse. Situé au cœur du village de La Grave, il permet de profiter à pied des commerces, du téléphérique et des sentiers, avec des vues dégagées sur la Meije et l'église classée du village.",
    'epidote.descTitle': 'Description',
    'epidote.equipTitle': 'Équipements',
    'epidote.equip': [
      'Duplex de 83 m² pour 6 personnes',
      'Orientation sud et ouest',
      "Trois chambres réparties à l'étage",
      'Cuisine ouverte entièrement équipée (plaques, four, lave-vaisselle, petit électroménager)',
      'Grand espace repas et salon avec poêle à bois et TV connectée',
      'Deux salles de bain avec douche',
      'Deux WC',
      "Balcon avec vue sur l'église du village",
      'Accès au ski room avec casier privatif',
      'Connexion Wi-Fi haut débit',
      'Logement situé au cœur du village de La Grave',
    ],
    'epidote.infoTitle': 'Informations pratiques',
    'epidote.capacity': 'Capacité',
    'epidote.capacityVal': '6 personnes',
    'epidote.surface': 'Surface',
    'epidote.surfaceVal': '83 m² (duplex)',
    'epidote.rate': 'Tarif',
    'epidote.rateVal': 'À partir de 145 €',
    'epidote.perNight': '/ nuit',
    'epidote.bookAirbnb': 'Réserver sur Airbnb',
    'epidote.back': 'Retour aux appartements',
    'seo.epidote.title': 'Appartement Épidote – Grand duplex 6 personnes à La Grave | La Marmotte Joyeuse',
    'seo.epidote.description': "Grand duplex de 83 m² pour 6 personnes avec balcon. Idéal en famille ou entre amis à La Grave. Cuisine équipée, terrasse, ski room, Wi-Fi haut débit face à la Meije.",

    // ─── Page FAQ ───
    'faq.title': 'Questions Fréquentes',
    'faq.subtitle': 'Tout ce qu\'il faut savoir avant et pendant votre séjour à La Marmotte Joyeuse.',
    'faq.all': 'Toutes',
    'faq.cat.logement': 'Logement & Séjour',
    'faq.cat.activites': 'Activités',
    'faq.cat.services': 'Services',
    'faq.cat.pratique': 'Infos pratiques',
    'faq.contactCta': "Vous n'avez pas trouvé votre réponse ?",
    'faq.contactSub': 'Notre équipe est disponible pour répondre à toutes vos questions.',
    'faq.contactLink': 'Nous contacter',
    'seo.faq.title': 'FAQ - Questions Fréquentes | La Marmotte Joyeuse',
    'seo.faq.description': 'Trouvez les réponses à vos questions sur votre séjour à La Marmotte Joyeuse à La Grave : logement, activités, services et informations pratiques.',
    'faq.q1.question': 'Où se situent les appartements La Marmotte Joyeuse ?',
    'faq.q1.answer': "Les appartements La Marmotte Joyeuse sont situés au cœur du village de La Grave, face au massif de la Meije, dans une maison de village authentique. Ils offrent un accès facile aux commerces, au téléphérique, aux sentiers de randonnée et aux activités de montagne été comme hiver.",
    'faq.q1.category': 'logement',
    'faq.q2.question': 'Combien de personnes peuvent séjourner dans les appartements ?',
    'faq.q2.answer': "Chaque appartement est conçu pour accueillir un nombre précis de voyageurs, indiqué dans l'annonce de location. Pour le confort de tous et le respect du voisinage, la capacité maximale doit être strictement respectée.",
    'faq.q2.category': 'logement',
    'faq.q3.question': 'Le logement est-il calme ?',
    'faq.q3.answer': "La Marmotte Joyeuse se situe dans un village de montagne apprécié pour son calme. Les appartements sont destinés à des séjours reposants ; le respect du voisinage est essentiel, notamment en soirée. Les logements ne sont pas adaptés aux fêtes ou rassemblements.",
    'faq.q3.category': 'logement',
    'faq.q4.question': 'Les appartements sont-ils non-fumeurs ?',
    'faq.q4.answer': "Oui. Tous les appartements sont entièrement non-fumeurs. Il est toutefois possible de fumer à l'extérieur, dans le respect des lieux et de l'environnement.",
    'faq.q4.category': 'logement',
    'faq.q5.question': 'Les animaux sont-ils acceptés ?',
    'faq.q5.answer': "Non, les animaux de compagnie ne sont pas acceptés dans les appartements ni dans les parties communes.",
    'faq.q5.category': 'logement',
    'faq.q6.question': 'Les appartements conviennent-ils aux familles avec enfants ?',
    'faq.q6.answer': "Les appartements peuvent accueillir des enfants, sous la responsabilité exclusive des parents ou accompagnateurs. Les logements ne sont pas spécifiquement équipés en matériel de puériculture.",
    'faq.q6.category': 'logement',
    'faq.q7.question': 'Y a-t-il des dispositifs de sécurité dans la résidence ?',
    'faq.q7.answer': "Un dispositif de vidéosurveillance est présent uniquement dans le local à ski, à des fins de sécurité du matériel. Aucun dispositif de ce type n'est installé dans les appartements ou les espaces privatifs.",
    'faq.q7.category': 'logement',
    'faq.q8.question': 'Les appartements sont-ils adaptés aux séjours de ski ?',
    'faq.q8.answer': "Oui. Les appartements sont particulièrement adaptés aux séjours de ski et de sports de montagne.\n\nUn local à ski sécurisé est mis à disposition, avec casier privatif et sèche-chaussures, afin de stocker et sécher le matériel dans de bonnes conditions.",
    'faq.q8.category': 'activites',
    'faq.q9.question': 'Peut-on faire des activités toute l\'année à La Grave ?',
    'faq.q9.answer': "Oui. La Grave est une destination quatre saisons :\n\n• Hiver : ski hors-piste, ski de randonnée, raquettes\n• Été : randonnée, alpinisme, escalade, via ferrata, VTT\n• Toute l'année : découverte du patrimoine, paysages alpins, gastronomie locale.",
    'faq.q9.category': 'activites',
    'faq.q10.question': 'Y a-t-il des équipements pour les vélos ou le matériel sportif ?',
    'faq.q10.answer': "Oui. Les vélos peuvent être stockés de manière sécurisée. La recharge des batteries de vélos électriques est autorisée sous certaines conditions de sécurité, précisées dans le règlement intérieur remis aux voyageurs.",
    'faq.q10.category': 'activites',
    'faq.q11.question': 'Le Wi-Fi est-il disponible dans les logements ?',
    'faq.q11.answer': "Oui, chaque appartement dispose d'une connexion Wi-Fi. Elle permet un usage courant (navigation, télétravail), dans le respect de la réglementation en vigueur.",
    'faq.q11.category': 'services',
    'faq.q12.question': 'Faut-il faire le ménage avant le départ ?',
    'faq.q12.answer': "Le ménage de fin de séjour est inclus.\n\nIl est simplement demandé aux voyageurs d'effectuer quelques gestes simples avant le départ (vaisselle, poubelles, rangement de base).",
    'faq.q12.category': 'services',
    'faq.q13.question': 'Le logement est-il adapté au télétravail ?',
    'faq.q13.answer': "La connexion Wi-Fi permet un usage professionnel dans de bonnes conditions.",
    'faq.q13.category': 'services',
    'faq.q14.question': 'Où peut-on se garer à La Grave ?',
    'faq.q14.answer': "Des solutions de stationnement gratuites sont disponibles à proximité du logement. Pour des raisons de sécurité et de circulation, il n'est pas possible de se garer devant la maison. Les indications pratiques sont fournies aux voyageurs avant l'arrivée.",
    'faq.q14.category': 'pratique',
    'faq.q15.question': 'Y a-t-il des commerces à La Grave ?',
    'faq.q15.answer': "Oui. La Grave dispose de commerces de proximité, boulangeries, épiceries, restaurants et cafés. Il n'y a pas de grand supermarché dans le village ; les plus proches se trouvent à Bourg-d'Oisans ou Briançon.",
    'faq.q15.category': 'pratique',
    'faq.q16.question': 'Y a-t-il des restaurants à proximité ?',
    'faq.q16.answer': "Oui. Plusieurs restaurants, auberges et établissements d'altitude sont accessibles à pied ou en quelques minutes. La cuisine locale met à l'honneur les produits de montagne et les spécialités alpines.",
    'faq.q16.category': 'pratique',
    'faq.q17.question': 'Où jeter ses déchets pendant le séjour ?',
    'faq.q17.answer': "La commune de La Grave applique le tri sélectif. Des points de collecte sont accessibles à proximité du logement. Les consignes sont précisées dans le livret d'accueil.",
    'faq.q17.category': 'pratique',
    'faq.q18.question': 'Comment contacter La Marmotte Joyeuse avant ou pendant le séjour ?',
    'faq.q18.answer': "Un contact dédié est communiqué aux voyageurs avant leur arrivée afin de répondre à leurs questions et de les accompagner pendant leur séjour.",
    'faq.q18.category': 'pratique',

    // ─── Page contact ───
    'contact.title': 'Contactez-nous',
    'contact.subtitle': "Une question sur votre séjour ? Besoin d'informations ? Notre équipe est à votre disposition pour vous accompagner.",
    'contact.coordTitle': 'Nos coordonnées',
    'contact.phone': 'Téléphone',
    'contact.phoneHours': 'Lun-Ven 9h-18h, Sam 9h-12h',
    'contact.email': 'Email',
    'contact.address': 'Adresse',
    'contact.hours': "Horaires d'ouverture",
    'contact.hoursVal': "Lundi - Vendredi : 9h - 18h\nSamedi : 9h - 12h\nDimanche : Fermé",
    'contact.mapTitle': 'Notre localisation',
    'seo.contact.title': 'Contact - La Marmotte Joyeuse | Réservez votre séjour dans les Alpes',
    'seo.contact.description': 'Contactez La Marmotte Joyeuse pour réserver votre séjour dans les Alpes. Téléphone, email, adresse à La Grave. Réponse rapide garantie.',

    // ─── Page photos ───
    'photos.title': 'Notre Album Photos',
    'photos.subtitle': 'Découvrez La Marmotte Joyeuse et ses environs en images.',
    'seo.photos.title': 'Album Photos - La Marmotte Joyeuse | Galerie d\'images des Alpes',
    'seo.photos.description': 'Découvrez en images nos appartements et les magnifiques paysages des Alpes françaises depuis La Marmotte Joyeuse. Vue panoramique, intérieurs chaleureux.',

    // ─── Page mentions légales ───
    'legal.title': 'Mentions légales',
    'legal.editor.title': 'Éditeur du site',
    'legal.editor.text': '<p><strong>LA MARMOTTE JOYEUSE</strong></p><p>Société par actions simplifiée (SAS) au capital de 3 000 €</p><p>Siège social : 1 rue René Guy Cadou – 44260 Savenay – France</p><p>SIREN : 907 898 928 — RCS Saint-Nazaire</p><p>Société non assujettie à la TVA (article 293 B du Code général des impôts).</p><p>Directeur de la publication : Madame Sophie Letard, Directrice de la société.</p>',
    'legal.activity.title': 'Activité',
    'legal.activity.text': "Le présent site est un site vitrine ayant pour objet la présentation de l'activité de location et de gestion de biens immobiliers à usage de séjour touristique, sans réservation ni paiement en ligne.",
    'legal.hosting.title': 'Hébergement du site',
    'legal.hosting.text': 'Le site est hébergé par OVHcloud — OVH SAS, 2 rue Kellermann, 59100 Roubaix – France. Téléphone : +33 (0)9 72 10 10 07.',
    'legal.credit.title': 'Crédit conception',
    'legal.credit.text': 'Conception du site : Théodore Letard',
    'legal.ip.title': 'Propriété intellectuelle',
    'legal.ip.text': "L'ensemble des contenus présents sur ce site (textes, photographies, visuels, logos, éléments graphiques, documents, etc.) est la propriété exclusive de la société LA MARMOTTE JOYEUSE, sauf mention contraire. Toute reproduction, représentation, modification, publication ou adaptation, totale ou partielle, de ces éléments, quel que soit le moyen ou le procédé utilisé, est interdite sans autorisation écrite préalable.",
    'legal.data.title': 'Données personnelles',
    'legal.data.text': "Le présent site est un site vitrine. Il ne comporte aucun formulaire, ne collecte aucune donnée personnelle et n'utilise aucun dispositif de suivi ou de traçage. Les échanges initiés par courrier électronique sont traités uniquement afin de répondre à la demande formulée. Aucune donnée n'est cédée à des tiers ni utilisée à des fins commerciales. Conformément au Règlement (UE) 2016/679 (RGPD), toute personne peut exercer ses droits d'accès, de rectification ou de suppression des données la concernant en adressant une demande à l'adresse électronique mentionnée ci-dessus.",
    'legal.cookies.title': 'Cookies',
    'legal.cookies.text': "Ce site n'utilise aucun cookie ni traceur, qu'il soit technique, statistique ou publicitaire. Aucun bandeau de consentement n'est requis.",
    'legal.liability.title': 'Responsabilité',
    'legal.liability.text': "La société LA MARMOTTE JOYEUSE s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur le site. Elle ne saurait toutefois être tenue responsable des erreurs, omissions ou d'une indisponibilité temporaire du site.",
    'legal.law.title': 'Droit applicable',
    'legal.law.text': "Le présent site est soumis au droit français. En cas de litige, et à défaut de résolution amiable, les tribunaux français territorialement compétents seront seuls compétents.",
    'seo.legal.title': 'Mentions Légales | La Marmotte Joyeuse',
    'seo.legal.description': 'Mentions légales du site La Marmotte Joyeuse — éditeur, hébergement, propriété intellectuelle et données personnelles.',

    // ─── Footer ───
    'footer.contact': 'Nous contacter',
    'footer.legal': 'Mentions légales',
    'footer.rights': 'Tous droits réservés.',

    // ─── Page 404 ───
    'notfound.title': 'Page introuvable',
    'notfound.text': "La page que vous cherchez n'existe pas.",
    'notfound.back': "Retour à l'accueil",
  },

  en: {
    // ─── Header / Navigation ───
    'nav.appartements': 'Apartments',
    'nav.album': 'Photo gallery',
    'nav.faq': 'FAQ',
    'nav.darkMode': 'Dark mode',
    'nav.lightMode': 'Light mode',
    'nav.settings': 'Settings',

    // ─── Hero accueil ───
    'hero.location': 'La Grave · French Alps',
    'hero.title': 'La Marmotte Joyeuse',
    'hero.subtitle': 'Renovated apartments facing the Meije glacier.',
    'hero.cta': 'View our apartments',
    'hero.scroll': 'Scroll',

    // ─── Section histoire ───
    'story.label': 'Our Story',
    'story.title': 'Welcome to La Marmotte Joyeuse',
    'story.p1': "A 19th-century house fully renovated in 2026, in the heart of the beautiful village of La Grave, facing the Meije. An authentic village house that hosts three apartments named after iconic minerals of the Oisans region:",
    'story.minerals': 'Quartz, Sidérite and Épidote',
    'story.p2': 'Experience life in a mountain village listed among the "Most Beautiful Villages of France" — shops, restaurants and cable car within walking distance, GR 54 trail just steps away.',

    // ─── Section localisation ───
    'location.title': 'Our location',
    'location.address': '2 Impasse du Garde Champêtre, 05320 La Grave',
    'location.openMaps': 'Open in Google Maps',

    // ─── SEO accueil ───
    'seo.home.title': 'La Marmotte Joyeuse - Charming accommodation in the Alps | La Grave',
    'seo.home.description': 'Discover La Marmotte Joyeuse, your mountain retreat in the heart of the French Alps. Comfortable apartments, panoramic views, mountain activities. Book your unforgettable stay in La Grave.',

    // ─── Page appartements ───
    'apts.title': 'Our Apartments',
    'apts.subtitle': 'Three renovated apartments in the heart of La Grave village, facing the Meije.',
    'apts.features': 'Features',
    'apts.viewApt': 'View this apartment',
    'apts.quartz.title': 'Apartment Quartz',
    'apts.quartz.desc': 'Duplex 35 m² · 2 guests · Meije view',
    'apts.quartz.price': 'From €85/night',
    'apts.quartz.f1': 'Cosy duplex',
    'apts.quartz.f2': 'Perfect for solo or couple',
    'apts.quartz.f3': 'Meije view',
    'apts.siderite.title': 'Apartment Sidérite',
    'apts.siderite.desc': 'Ground floor 63 m² · 4 guests · South-facing view',
    'apts.siderite.price': 'From €115/night',
    'apts.siderite.f1': 'Ground floor apartment',
    'apts.siderite.f2': 'South-facing glacier view',
    'apts.siderite.f3': 'Perfect for 4 guests',
    'apts.epidote.title': 'Apartment Épidote',
    'apts.epidote.desc': 'Large duplex 83 m² · 6 guests · Balcony',
    'apts.epidote.price': 'From €145/night',
    'apts.epidote.f1': 'Large duplex',
    'apts.epidote.f2': 'Perfect for families or friends',
    'apts.epidote.f3': '6 guests',
    'seo.apts.title': 'Our Apartments - La Marmotte Joyeuse | Charming accommodation in La Grave',
    'seo.apts.description': 'Discover our Quartz, Sidérite and Épidote apartments. Panoramic Meije views, modern amenities, an unforgettable stay in La Grave in the Alps.',

    // ─── Appartement Quartz ───
    'quartz.label': 'Apartment',
    'quartz.name': 'Quartz',
    'quartz.tagline': 'Duplex · 2 guests · La Grave',
    'quartz.desc': "The Quartz apartment is a cosy duplex designed for two, perfect for enjoying a stay in La Grave facing the Meije. With its bright living area, fully equipped kitchen and upstairs bedroom, Quartz offers a comfortable setting to discover the mountains with ease. Located in the heart of the village, it provides easy access to trails, shops and the iconic activities of La Grave, all while enjoying a quiet and authentic environment.",
    'quartz.descTitle': 'Description',
    'quartz.equipTitle': 'Amenities',
    'quartz.equip': [
      '35 m² duplex for 2 guests',
      'Meije view from the living area',
      'Upstairs bedroom with en-suite bathroom',
      'Fully equipped kitchen (hob, oven, dishwasher, small appliances)',
      'Living area with smart TV',
      'Bathroom with shower and storage',
      'Access to ski room with private locker',
      'High-speed Wi-Fi',
      'Located in the heart of La Grave village',
    ],
    'quartz.infoTitle': 'Practical information',
    'quartz.capacity': 'Capacity',
    'quartz.capacityVal': '2 guests',
    'quartz.surface': 'Surface area',
    'quartz.surfaceVal': '35 m² (duplex)',
    'quartz.rate': 'Rate',
    'quartz.rateVal': 'From €85',
    'quartz.perNight': '/ night',
    'quartz.bookAirbnb': 'Book on Airbnb',
    'quartz.back': 'Back to apartments',
    'seo.quartz.title': 'Apartment Quartz – Duplex for 2 in La Grave | La Marmotte Joyeuse',
    'seo.quartz.description': '35 m² duplex for 2 guests with Meije view from the living area. Equipped kitchen, bathroom, Wi-Fi, private ski room. In the heart of La Grave village.',

    // ─── Appartement Sidérite ───
    'siderite.label': 'Apartment',
    'siderite.name': 'Sidérite',
    'siderite.tagline': 'Ground floor · 4 guests · La Grave',
    'siderite.desc': "The Sidérite apartment is a ground-floor unit designed to accommodate up to four guests, ideal for a family or friends getaway in La Grave. South-facing, it offers a comfortable and bright living area open to the Meije, with easy direct access from the heart of the village. Sidérite is a convenient base for enjoying mountain activities, local shops and the authentic atmosphere of the village, summer and winter alike.",
    'siderite.descTitle': 'Description',
    'siderite.equipTitle': 'Amenities',
    'siderite.equip': [
      '63 m² ground-floor apartment for 4 guests',
      'South-facing with Meije view',
      'Two bedrooms (1 double bed and 2 single beds)',
      'Fully equipped kitchen (hob, oven, dishwasher, small appliances)',
      'Living area with wood stove and smart TV',
      'Bathroom with shower, washing machine and storage',
      'Separate WC',
      'Access to ski room with private locker',
      'High-speed Wi-Fi',
      'Located in the heart of La Grave village',
    ],
    'siderite.infoTitle': 'Practical information',
    'siderite.capacity': 'Capacity',
    'siderite.capacityVal': '4 guests',
    'siderite.surface': 'Surface area',
    'siderite.surfaceVal': '63 m² (ground floor)',
    'siderite.rate': 'Rate',
    'siderite.rateVal': 'From €115',
    'siderite.perNight': '/ night',
    'siderite.bookAirbnb': 'Book on Airbnb',
    'siderite.back': 'Back to apartments',
    'seo.siderite.title': 'Apartment Sidérite – Ground floor for 4 in La Grave | La Marmotte Joyeuse',
    'seo.siderite.description': '63 m² ground-floor apartment for 4 guests, south-facing glacier view. Equipped kitchen, Wi-Fi, ski room. Listed village of La Grave, facing the Meije.',

    // ─── Appartement Épidote ───
    'epidote.label': 'Apartment',
    'epidote.name': 'Épidote',
    'epidote.tagline': 'Large duplex · 6 guests · La Grave',
    'epidote.desc': "The Épidote apartment is a bright, spacious duplex that can accommodate up to six guests. Spread over two levels, it offers generous volumes and a layout suited to group stays, while maintaining a warm atmosphere. Located in the heart of La Grave village, it offers walking access to shops, the cable car and hiking trails, with open views of the Meije and the village's listed church.",
    'epidote.descTitle': 'Description',
    'epidote.equipTitle': 'Amenities',
    'epidote.equip': [
      '83 m² duplex for 6 guests',
      'South and west facing',
      'Three upstairs bedrooms',
      'Open fully equipped kitchen (hob, oven, dishwasher, small appliances)',
      'Large dining and living area with wood stove and smart TV',
      'Two bathrooms with shower',
      'Two WCs',
      'Balcony with view of the village church',
      'Access to ski room with private locker',
      'High-speed Wi-Fi',
      'Located in the heart of La Grave village',
    ],
    'epidote.infoTitle': 'Practical information',
    'epidote.capacity': 'Capacity',
    'epidote.capacityVal': '6 guests',
    'epidote.surface': 'Surface area',
    'epidote.surfaceVal': '83 m² (duplex)',
    'epidote.rate': 'Rate',
    'epidote.rateVal': 'From €145',
    'epidote.perNight': '/ night',
    'epidote.bookAirbnb': 'Book on Airbnb',
    'epidote.back': 'Back to apartments',
    'seo.epidote.title': 'Apartment Épidote – Large duplex for 6 in La Grave | La Marmotte Joyeuse',
    'seo.epidote.description': '83 m² duplex for 6 guests with balcony. Perfect for families or friends in La Grave. Equipped kitchen, terrace, ski room, high-speed Wi-Fi facing the Meije.',

    // ─── Page FAQ ───
    'faq.title': 'Frequently Asked Questions',
    'faq.subtitle': 'Everything you need to know before and during your stay at La Marmotte Joyeuse.',
    'faq.all': 'All',
    'faq.cat.logement': 'Accommodation',
    'faq.cat.activites': 'Activities',
    'faq.cat.services': 'Services',
    'faq.cat.pratique': 'Practical info',
    'faq.contactCta': "Didn't find your answer?",
    'faq.contactSub': 'Our team is available to answer all your questions.',
    'faq.contactLink': 'Contact us',
    'seo.faq.title': 'FAQ - Frequently Asked Questions | La Marmotte Joyeuse',
    'seo.faq.description': 'Find answers to your questions about staying at La Marmotte Joyeuse in La Grave: accommodation, activities, services and practical information.',
    'faq.q1.question': 'Where are La Marmotte Joyeuse apartments located?',
    'faq.q1.answer': "La Marmotte Joyeuse apartments are located in the heart of La Grave village, facing the Meije massif, in an authentic village house. They offer easy access to shops, the cable car, hiking trails and mountain activities all year round.",
    'faq.q2.question': 'How many guests can the apartments accommodate?',
    'faq.q2.answer': "Each apartment is designed to accommodate a specific number of guests, as indicated in the listing. For everyone's comfort and out of respect for neighbours, the maximum capacity must be strictly observed.",
    'faq.q3.question': 'Is the accommodation quiet?',
    'faq.q3.answer': "La Marmotte Joyeuse is located in a mountain village known for its peacefulness. The apartments are intended for restful stays; respect for neighbours is essential, especially in the evening. The accommodations are not suitable for parties or gatherings.",
    'faq.q4.question': 'Are the apartments non-smoking?',
    'faq.q4.answer': "Yes. All apartments are entirely non-smoking. However, smoking is permitted outside, with respect for the premises and the environment.",
    'faq.q5.question': 'Are pets allowed?',
    'faq.q5.answer': "No, pets are not allowed in the apartments or common areas.",
    'faq.q6.question': 'Are the apartments suitable for families with children?',
    'faq.q6.answer': "The apartments can accommodate children, under the exclusive responsibility of their parents or guardians. The accommodations are not specifically equipped with childcare equipment.",
    'faq.q7.question': 'Are there security devices in the property?',
    'faq.q7.answer': "A CCTV system is present only in the ski room, for equipment security purposes. No such device is installed in the apartments or private areas.",
    'faq.q8.question': 'Are the apartments suitable for skiing trips?',
    'faq.q8.answer': "Yes. The apartments are particularly well-suited for skiing and mountain sports stays.\n\nA secure ski room is available, with a private locker and boot dryer, to store and dry equipment in good conditions.",
    'faq.q9.question': 'Can you do activities year-round in La Grave?',
    'faq.q9.answer': "Yes. La Grave is a four-season destination:\n\n• Winter: off-piste skiing, ski touring, snowshoeing\n• Summer: hiking, mountaineering, climbing, via ferrata, mountain biking\n• Year-round: heritage discovery, alpine landscapes, local gastronomy.",
    'faq.q10.question': 'Are there facilities for bikes or sports equipment?',
    'faq.q10.answer': "Yes. Bikes can be stored securely. Charging e-bike batteries is permitted under certain safety conditions, specified in the house rules provided to guests.",
    'faq.q11.question': 'Is Wi-Fi available in the apartments?',
    'faq.q11.answer': "Yes, each apartment has a Wi-Fi connection. It supports everyday use (browsing, remote work), in compliance with current regulations.",
    'faq.q12.question': 'Do I need to clean before departure?',
    'faq.q12.answer': "End-of-stay cleaning is included.\n\nGuests are simply asked to perform a few simple tasks before departure (dishes, rubbish, basic tidying).",
    'faq.q13.question': 'Is the accommodation suitable for remote work?',
    'faq.q13.answer': "The Wi-Fi connection supports professional use in good conditions.",
    'faq.q14.question': 'Where can I park in La Grave?',
    'faq.q14.answer': "Free parking options are available near the property. For safety and traffic reasons, parking directly in front of the house is not possible. Practical directions are provided to guests before arrival.",
    'faq.q15.question': 'Are there shops in La Grave?',
    'faq.q15.answer': "Yes. La Grave has local shops, bakeries, grocery stores, restaurants and cafés. There is no large supermarket in the village; the nearest ones are in Bourg-d'Oisans or Briançon.",
    'faq.q16.question': 'Are there restaurants nearby?',
    'faq.q16.answer': "Yes. Several restaurants, inns and mountain establishments are accessible on foot or within a few minutes. Local cuisine highlights mountain produce and alpine specialities.",
    'faq.q17.question': 'Where to dispose of waste during the stay?',
    'faq.q17.answer': "The municipality of La Grave applies selective sorting. Collection points are accessible near the property. Instructions are provided in the welcome booklet.",
    'faq.q18.question': 'How to contact La Marmotte Joyeuse before or during the stay?',
    'faq.q18.answer': "A dedicated contact is provided to guests before their arrival to answer their questions and assist them during their stay.",

    // ─── Page contact ───
    'contact.title': 'Contact us',
    'contact.subtitle': 'Have a question about your stay? Need information? Our team is here to help.',
    'contact.coordTitle': 'Our details',
    'contact.phone': 'Phone',
    'contact.phoneHours': 'Mon-Fri 9am-6pm, Sat 9am-12pm',
    'contact.email': 'Email',
    'contact.address': 'Address',
    'contact.hours': 'Opening hours',
    'contact.hoursVal': "Monday - Friday: 9am - 6pm\nSaturday: 9am - 12pm\nSunday: Closed",
    'contact.mapTitle': 'Our location',
    'seo.contact.title': 'Contact - La Marmotte Joyeuse | Book your stay in the Alps',
    'seo.contact.description': 'Contact La Marmotte Joyeuse to book your stay in the Alps. Phone, email, address in La Grave. Fast response guaranteed.',

    // ─── Page photos ───
    'photos.title': 'Photo Gallery',
    'photos.subtitle': 'Discover La Marmotte Joyeuse and its surroundings in pictures.',
    'seo.photos.title': 'Photo Gallery - La Marmotte Joyeuse | Alpine images',
    'seo.photos.description': 'Discover our apartments and the stunning scenery of the French Alps from La Marmotte Joyeuse. Panoramic views, warm interiors.',

    // ─── Page mentions légales ───
    'legal.title': 'Legal notice',
    'legal.editor.title': 'Site publisher',
    'legal.editor.text': '<p><strong>LA MARMOTTE JOYEUSE</strong></p><p>Simplified joint-stock company (SAS) with a share capital of €3,000</p><p>Registered office: 1 rue René Guy Cadou – 44260 Savenay – France</p><p>SIREN: 907 898 928 — RCS Saint-Nazaire</p><p>Company exempt from VAT (article 293 B of the French Tax Code).</p><p>Publication director: Ms Sophie Letard, Company Director.</p>',
    'legal.activity.title': 'Activity',
    'legal.activity.text': "This website is a showcase site whose purpose is to present the activity of rental and management of real estate properties for tourist stays, without online booking or payment.",
    'legal.hosting.title': 'Site hosting',
    'legal.hosting.text': 'The site is hosted by OVHcloud — OVH SAS, 2 rue Kellermann, 59100 Roubaix – France. Phone: +33 (0)9 72 10 10 07.',
    'legal.credit.title': 'Design credit',
    'legal.credit.text': 'Site design: Théodore Letard',
    'legal.ip.title': 'Intellectual property',
    'legal.ip.text': "All content on this site (texts, photographs, visuals, logos, graphic elements, documents, etc.) is the exclusive property of LA MARMOTTE JOYEUSE, unless otherwise stated. Any reproduction, representation, modification, publication or adaptation, in whole or in part, of these elements, by any means or process, is prohibited without prior written authorisation.",
    'legal.data.title': 'Personal data',
    'legal.data.text': "This site is a showcase site. It does not contain any forms, does not collect any personal data and does not use any tracking devices. Communications initiated by email are processed solely to respond to the request made. No data is shared with third parties or used for commercial purposes. In accordance with Regulation (EU) 2016/679 (GDPR), any person may exercise their rights of access, rectification or deletion of their data by sending a request to the email address mentioned above.",
    'legal.cookies.title': 'Cookies',
    'legal.cookies.text': "This site does not use any cookies or trackers, whether technical, statistical or advertising. No consent banner is required.",
    'legal.liability.title': 'Liability',
    'legal.liability.text': "LA MARMOTTE JOYEUSE endeavours to ensure the accuracy and updating of information published on the site. However, it cannot be held responsible for errors, omissions or temporary unavailability of the site.",
    'legal.law.title': 'Applicable law',
    'legal.law.text': "This site is subject to French law. In the event of a dispute, and failing amicable resolution, the competent French courts shall have sole jurisdiction.",
    'seo.legal.title': 'Legal Notice | La Marmotte Joyeuse',
    'seo.legal.description': 'Legal notice for the La Marmotte Joyeuse website — publisher, hosting, intellectual property and personal data.',

    // ─── Footer ───
    'footer.contact': 'Contact us',
    'footer.legal': 'Legal notice',
    'footer.rights': 'All rights reserved.',

    // ─── Page 404 ───
    'notfound.title': 'Page not found',
    'notfound.text': "The page you're looking for doesn't exist.",
    'notfound.back': 'Back to home',
  }
};
